import {Component, HostListener, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatMenuTrigger} from "@angular/material/menu";

@Component({
  selector: 'app-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.css'], encapsulation: ViewEncapsulation.None
})
export class HeadingComponent {
  isMenuClicked = false;

  @ViewChild(MatMenuTrigger) matMenuTrigger!: MatMenuTrigger;

  onMenuClick() {
    this.isMenuClicked = !this.isMenuClicked;
  }

  onMenuClosed() {
    this.isMenuClicked = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    const width = (event.target as Window).innerWidth;
    if (width > 932 && this.isMenuClicked) {
      this.matMenuTrigger.closeMenu();
      this.isMenuClicked = false;
    }
  }
}
